import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type DashboardCardProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export const DashboardCard = ({
  title,
  subtitle,
  action,
  children,
  className,
}: DashboardCardProps) => {
  return (
    <div
      className={cn(
        "rounded-xl bg-card p-4 md:p-6 border border-border/50 flex flex-col shadow-sm dark:shadow-none",
        className
      )}
    >
      <header className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>
          )}
        </div>
        {action}
      </header>
      <div className="flex-1">{children}</div>
    </div>
  );
};
